<div class="container">
    <div class="header">
      <p class="font-18 black-color">Account Billing History</p>
    </div>
    <div class="container-filter">
      <div class="form-group" [formGroup]="filterForm">
        <select class="form-select" (change)="dateFilterClick()" formControlName="filter_prov">
          <!-- <option value="" >Last Month</option>
            <option value="" >Last Year</option>
            <option value="" >Custom Range</option> -->
          <option *ngFor="let type of filterTypes; trackBy: trackByFilterType">
            {{ type.value }}
          </option>
        </select>
      </div>
      <div class="flex">
        <button mat-flat-button (click)="ResetFilters()" class="edit-form-button danger-btn btn-width margin-right-10px">
          Clear Filter
        </button>
        <button mat-flat-button (click)="openAdvancedFilters()" class="edit-form-button danger-btn btn-width ">
          Advanced Filter
        </button>
      </div>
    </div>
  
    <!-- <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Transaction Date</th>
        <td mat-cell *matCellDef="let element">{{ element.date }}</td>
      </ng-container>
  
  
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Payment Type</th>
        <td mat-cell *matCellDef="let element">{{ element.type }}</td>
      </ng-container> -->
  
    <!-- <ng-container matColumnDef="vehicle">
        <th mat-header-cell *matHeaderCellDef>Vehicle</th>
        <td mat-cell *matCellDef="let element">{{ element.vehicle }}</td>
      </ng-container> -->
  
    <!-- <ng-container matColumnDef="desc">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let element">{{ element.desc }}</td>
      </ng-container>
  
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let element">{{ element.amount }}</td>
      </ng-container>
  
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <button
            mat-flat-button
            class="view-btn"
            (click)="getRecord(element.action)"
          >
            View
          </button>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table> -->
  
    <div class="table-container">
      <table matSort class="card-table" mat-table [dataSource]="dataSource" [trackBy]="trackByBillingRecord" matSortActive="date" matSortDirection="desc"
        matSortDisableClear>
  
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
          <td mat-cell *matCellDef="let element" class="row-data"> {{element.date}} </td>
        </ng-container>
  
        <!-- Transaction Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Transaction Type </th>
          <td mat-cell *matCellDef="let element" class="row-data"> {{element.type}} </td>
        </ng-container>
  
        <!-- Description Type Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef> Description </th>
          <td mat-cell *matCellDef="let element" class="row-data"> {{element.desc}} </td>
        </ng-container>
  
        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount </th>
          <td mat-cell *matCellDef="let element" class="row-data"> $ {{element.amount}} </td>
        </ng-container>
  
        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef> Action </th>
          <td mat-cell *matCellDef="let element" class="action-link row-data">
            <div *ngIf="element.filterType === 'Invoice'">
              <!-- <a title="Download PDF"  (click)="this.viewInvoice(element, true)" role="button" tabindex="0" aria-label="Download PDF" (keydown.enter)="this.viewInvoice(element, true)" (keydown.space)="$event.preventDefault(); this.viewInvoice(element, true)"><mat-icon>picture_as_pdf</mat-icon></a>
                      <a  title="View Report"  (click)="this.viewInvoice(element, false)" role="button" tabindex="0" aria-label="View Report" (keydown.enter)="this.viewInvoice(element, false)" (keydown.space)="$event.preventDefault(); this.viewInvoice(element, false)">View</a> -->
              <button mat-flat-button class="view-btn" (click)="viewInvoice(element, false)">
                View
              </button>
            </div>
  
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
  
      <div class="text-center-align padding-top-10 red-color font-14" *ngIf="filteredData && filteredData.length === 0">No
        records found
      </div>
  
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="5" showFirstLastButtons></mat-paginator>
    </div>
  
  </div>
